export default __webpack_public_path__ + "static/media/cs_icon_05_on.d507918a.png";